module.exports = (__webpack_require__(2))("./core/disableChromePullToRefresh.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/disableChromePullToRefresh.js from dll-reference base
// module id = 93
// module chunks = 22